import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import DataActions from '../redux/dataRedux'
import { makeGetEventData } from '../selectors/eventDataSelector'
import getDateFromTimeIso from '../utility/getDateFromTimeIso'
import getBefore from '../utility/getBefore'

const id = 'PipelineBasic'
const authId = 'Pipeline'
const datetimeId = 'PipelineGreen'

const SOURCE_URL = ({ idToken, timeIso }) =>
      `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3APipelineGreen&width=512&height=512&srs=EPSG:3857&format=image%2Fpng8&transparent=true&TIME=${encodeURIComponent(
    timeIso
  )}&BBOX={bbox-epsg-3857}&token=${idToken}`

const SENTINEL2_URL = ({ timeIso, timeIso2, format='jpeg' }) =>
      `https://services.sentinel-hub.com/ogc/wms/318be53b-974b-4918-8f5f-53ba0a37079c?showLogo=false&service=WMTS&request=GetMap&layers=TRUE_COLOR&styles=&format=image%2F${format}&transparent=true&version=1.1.1&time=${encodeURIComponent(
    getDateFromTimeIso(timeIso)
  )}%2F${encodeURIComponent(
    getDateFromTimeIso(timeIso2)
  )}&name=Sentinel-2&maxcc=60&height=512&width=512&srs=EPSG%3A3857&bbox={bbox-epsg-3857}&exceptions=BLANK`

const layout = {
  'line-cap': 'round'
}

export class WellsiteNdviControl extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions, hovered } = this.props
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)
      
      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time } = this.props
    const visible = layerRendered
    const before = 'default'
    const timeIso = time ? new Date(time).toISOString() : ''
    const timeIso2 = time ? new Date(time + 3.456e+8).toISOString() : ''

    const rasterSource = {
      type: 'raster',
      tiles: [SOURCE_URL({ idToken, timeIso })],
      tileSize: 512
    }
    const sentinelSource = {
      type: 'raster',
      tiles: [SENTINEL2_URL({ idToken, timeIso, timeIso2, format: 'png' })],
      tileSize: 512
    }

    if (!visible) {
      return null
    }

    const { map } = this.context
    window.map = map

    return (
      <div>
        <Source
          id={id+'Sentinel2'}
          tileJsonSource={sentinelSource}
          />,
        <Layer
      type='raster'
      id={id+'Sentinel2'}
      sourceId={id+'Sentinel2'}
      before={before}
        />
        <Source
          id={id}
          tileJsonSource={rasterSource}
          />,
      <Layer
        type='raster'
        id={id}
        sourceId={id}
      paint={paint}
      before={getBefore(this.context, ['EnbridgePipeline'])}
        />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const getDatetime = makeGetDatetime()
  const getEventData = makeGetEventData()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        id,
        authId
      ),
      paint: getPaint(state, id),
      time: state.layer.times[datetimeId] || undefined,
      datetime: getDatetime(state, id) || '',
      hovered: getEventData(state, id)
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, id, event))
    }
  }
}

export default connect(makeMapStateToProps(), mapDispatchToProps)(WellsiteNdviControl)



// WEBPACK FOOTER //
// ./src/layers/PipelineBasic.js